import { render, staticRenderFns } from "./fivePage.vue?vue&type=template&id=6c2ebbe7&"
import script from "./fivePage.vue?vue&type=script&lang=js&"
export * from "./fivePage.vue?vue&type=script&lang=js&"
import style0 from "./fivePage.vue?vue&type=style&index=0&id=6c2ebbe7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports